import * as React from "react";
import { Select } from "antd";
import { ServiceContext } from "src/services/provider/Service.provider";
import { useContext, useState, useEffect } from "react";
import { FormComponentProps } from "antd/lib/form";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { ShowNotification } from '../ShowNotification/ShowNotification';
import { SelectValue } from 'antd/lib/select';
import { IIssuingAuthority } from 'src/services/interfaces/IIssuingAuthority';

interface ISelecIssuingAuthorityProps {
  onChange: (value: SelectValue) => void;
  nameIssuingAuthority: string;
  isIssuingrequired: boolean;
  name: string;
}

export const SelectIssuingAuthority: React.FC<ISelecIssuingAuthorityProps & FormComponentProps> = ({ form, onChange, nameIssuingAuthority, isIssuingrequired, name }) => {
  const { commonDomainService } = useContext(ServiceContext);

  const [selecIssuingAuthority, setSelectselecIssuingAuthority] = useState<IIssuingAuthority[]>([]);

  useEffect(() => {
    fetch();
  }, []);

  function fetch() {
    commonDomainService.getDomainByCode("rg_issuing_authority")
      .then(resp => {
        setSelectselecIssuingAuthority(resp.rg_issuing_authority_configuration_json);
      })
      .catch((err) => {
        ShowNotification.Error("Erro ao carregar lista de Orgãos!", "Não foi possível carregar lista de Orgãos, entre em contato.");
      });
  }

  return (
    <>
      <PbrSelect
        name={name}
        size="large"
        formItemProps={{ label: "Orgão expedidor" }}
        formWrapper={form}
        value={nameIssuingAuthority}
        onChange={onChange}
        placeholder="Selecione o orgão expedidor"
        rules={[{ required: isIssuingrequired, message: "Informe o orgão expedidor" }]}
        showSearch
      >
        {!nameIssuingAuthority && <Select.Option key="" disabled value={null}>Selecione o orgão expedidor</Select.Option>}
        {selecIssuingAuthority.map((obj) => (
          <Select.Option key={obj.name} value={obj.name}>{obj.name}</Select.Option>
        ))}
      </PbrSelect>
    </>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/SelectIssuingAuthority/SelectIssuingAuthority.tsx